import { inject, Injectable } from "@angular/core";
import { StrategyService } from "@front/m19-injection-token";
import { StrategyEx } from "@front/m19-models";
import { Observable, tap } from "rxjs";
import { ToasterService } from "@front/m19-ui";
import { Strategy } from "@front/m19-api-client";
import { TranslocoService } from "@jsverse/transloco";

export interface DaypartingConfig {
  strategy: StrategyEx;
  organizationId: number;
  daypartingPauseHour: number;
  daypartingReactivationHour: number;
  enabledDayParting: boolean;
}

@Injectable({ providedIn: "root" })
export class DaypartingService {
  private readonly strategyService = inject(StrategyService);
  private readonly toasterService = inject(ToasterService);
  private readonly translocoService = inject(TranslocoService);

  saveConfig(config: DaypartingConfig): Observable<Strategy> {
    const strategy = config.strategy;
    if (!config.enabledDayParting) {
      return this.strategyService
        .disableDayParting(strategy.accountId, strategy.marketplace, config.organizationId, strategy.strategyId)
        .pipe(
          tap({
            next: () => {
              this.toasterService.success(this.translocoService.translate("day-parting.day_parting_disabled"));
            },
            error: (error) => {
              this.toasterService.error(error.error.message);
            },
          }),
        );
    }
    return this.strategyService
      .updateStrategyHoursDayParting(
        strategy.accountId,
        strategy.marketplace,
        config.organizationId,
        strategy.strategyId,
        config.daypartingPauseHour,
        config.daypartingReactivationHour,
      )
      .pipe(
        tap({
          next: () => {
            this.toasterService.success(this.translocoService.translate("day-parting.day_parting_updated"));
          },
          error: (error) => {
            this.toasterService.error(error.error.message);
          },
        }),
      );
  }
}
